<div class="row rounded-card overflow-visible" id="serialization-settings">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="serialisation-settings-title">{{ 'SYSTEM_SETTINGS.SERIALIZATION.TITLE' | translate }}</h2>
      <span data-testid="serialisation-settings-subtitle" class="text-base">{{ 'SYSTEM_SETTINGS.SERIALIZATION.SUBTITLE' | translate }}</span>
    </div>
    <div class="actions-wr">
      <div class="flex items-center gap-2">
        @if (!showCreateForm) {
          <button data-testid="add-serialisation-btn" type="button" class="btn primary-btn" (click)="displayCreateFormForMissingSerializationType()">
            Add serialisation
          </button>
        }
      </div>
      @if (showCreateForm && !editingSetting) {
        <div class="flex items-center gap-2">
          <button data-testid="add-serialisation-cancel-btn"  type="button" class="btn outline-btn" (click)="cancelEdit()">
            {{ 'SYSTEM_SETTINGS.SERIALIZATION.CANCEL_SERIALIZATION_SETTINGS_EDIT_BTN' | translate }}
          </button>
        </div>
      }
    </div>
  </div>

  <hr class="mb-1 mt-2 border-t">
  @if (!loadingSettings && serializationSettings.length === 0 && !showCreateForm) {
    <section class="row">
      <div class="flex flex-col items-center pt-4 pb-2 text-center">
        <p class="block text-base mb-3">
          {{ 'SYSTEM_SETTINGS.SERIALIZATION.NO_SETTINGS_DEFINED' | translate }}
        </p>
        <button data-testid="add-serialisation-btn" type="button" class="btn primary-btn" (click)="toggleCreateForm()">
          {{ 'SYSTEM_SETTINGS.SERIALIZATION.ADD_SERIALIZATION_SETTINGS_BTN' | translate }}
        </button>
      </div>
    </section>
  }

  <!-- Create serialization settings -->
  @if (showCreateForm) {
    <form [formGroup]="generatorForm">
      <section class="row">
        <div class="flex flex-col col-12 mb-4">
          <h3 data-testid="serialisation-label" class="border-b pb-3">{{ editingSetting ? ('Editing: ' + getTypeLabel(mapTypeFromBackend(editingSetting.codeType)) + ' serialisation') : ('SYSTEM_SETTINGS.SERIALIZATION.SERIALIZATION_CONFIGURATION'| translate) }}</h3>
        </div>
        <!-- Algorithm Type -->
        <div class="field-wr col-12 col-md-12">
          <label data-testid="algorithm" class="block text-sm mb-2">
            {{ 'SYSTEM_SETTINGS.SERIALIZATION.ALGORITHM_TYPE' | translate }}
            <i class="icon-required-field"></i>
          </label>
          <div id="algorithm-types" class="grid grid-cols-1 gap-x-4 gap-y-2">
            @for (option of algorithmOptions; track option) {
              <span [attr.data-testid]="'algorithm-type-' + option.value + '-label'" class="inline-flex items-start ">
                <p-radioButton [attr.data-testid]="'algorithm-type-' + option.value"name="algorithm" [value]="option.value" formControlName="algorithm"
                [inputId]="option.value"></p-radioButton>
                <label [for]="option.value" class="ml-2">
                  {{ option.label }} -
                  <span class="text-gray-500 text-sm">{{ option.description }}</span>
                </label>
              </span>
            }
          </div>
        </div>
        <!-- Serialization Type -->
        @if (!editingSetting) {
          <div class="field-wr col-12 col-md-4">
            <label data-testid="serialisation-type-label" for="type" class="block text-sm mb-2">{{ 'SYSTEM_SETTINGS.SERIALIZATION.SERIALIZATION_TYPE' | translate }} <i class="icon-required-field"></i></label>
            <app-custom-dropdown
              data-testid="serialization-type"
              [options]="serializationTypeOptions"
              optionLabel="label"
              optionValue="value"
              [isMultiselect]="false"
              [showSelectionChips]="true"
              [showClear]="true"
              [showSearchbox]="false"
              [searchMode]="'local'"
              [pageSize]="10"
              [placeholder]="'SYSTEM_SETTINGS.SERIALIZATION.SELECT_SERIALIZATION_TYPE' | translate"
              formControlName="type">
            </app-custom-dropdown>
          </div>
        }
        <!-- Output Format -->
        <div class="field-wr col-12 col-md-4">
          <label data-testid="output-format-label" for="outputFormat" class="block text-sm mb-2">{{ 'SYSTEM_SETTINGS.SERIALIZATION.OUTPUT_FORMAT' | translate }} <i class="icon-required-field"></i></label>
          <app-custom-dropdown
            data-testid="output-format"
            [options]="outputFormatOptions"
            optionLabel="label"
            optionValue="value"
            [isMultiselect]="false"
            [showSelectionChips]="true"
            [showClear]="true"
            [showSearchbox]="false"
            [searchMode]="'local'"
            [pageSize]="10"
            [placeholder]="'SYSTEM_SETTINGS.SERIALIZATION.SELECT_OUTPUT_FORMAT' | translate"
            formControlName="outputFormat">
          </app-custom-dropdown>
        </div>
        <!-- Code Length -->
        <div class="field-wr col-12 col-md-2">
          <label data-testid="serialisation-code-length-label" for="codeLength" class="block text-sm">{{ 'SYSTEM_SETTINGS.SERIALIZATION.CODE_LENGTH' | translate }} <i class="icon-required-field"></i></label>
          <input data-testid="serialisation-code-length-input" type="number" id="codeLength" formControlName="codeLength" min="1" max="50" class="text-field">
        </div>
      </section>
      <!-- Mask Configuration -->
      @if (showMaskConfiguration) {
        <section class="row">
          <div class="flex flex-col col-12 mb-4">
            <h3 data-testid="mask-configuration" class="border-b pb-3">{{ 'SYSTEM_SETTINGS.SERIALIZATION.MASK_CONFIGURATION' | translate }}</h3>
          </div>
          <!-- Mask Pattern -->
          <app-notice class="block pb-3"
            type="blue"
            icon="warning-icon"
            dataTestId="mask-url-notice"
            [title]="'SYSTEM_SETTINGS.SERIALIZATION.MASK_URL_NOTICE_TITLE' | translate"
            [message]="'SYSTEM_SETTINGS.SERIALIZATION.MASK_URL_NOTICE_MESSAGE' | translate">
          </app-notice>
          <div class="field-wr col-12">
            <label data-testid="serialisation-mask-label" for="mask" class="block text-sm">{{ 'SYSTEM_SETTINGS.SERIALIZATION.MASK_PATTERN' | translate }}</label>
            <input data-testid="serialisation-mask-input" type="text" formControlName="mask" class="text-field font-mono" placeholder="e.g., aaa-bbbb-ccc">
            <small data-testid="mask-error" class="text-sm italic mt-2 block">
              {{ 'SYSTEM_SETTINGS.SERIALIZATION.DESCRIPTION_CHARACTER_TYPES' | translate }}
            </small>
            @if (generatorForm.hasError('maskTooLong')) {
              <small class="p-error">Mask length cannot exceed code length.</small>
            }
          </div>
          <!-- Presets & Character Sets -->
          <div class="col-12">
            <div class="flex items-center justify-between mb-4">
              <h3 data-testid="character-sets" class="section-subtitle">{{ 'SYSTEM_SETTINGS.SERIALIZATION.CHARACTER_SETS' | translate }}</h3>
              <button data-testid="add_character-type-btn" type="button" (click)="addNewMaskChar()" class="btn outline-btn small">{{
              'SYSTEM_SETTINGS.SERIALIZATION.BTN_ADD_CHARACTER_TYPE' | translate }}</button>
            </div>
            <!-- Preset helper -->
            <div class="pt-3 pb-3 px-4 bg-gray rounded mb-6">
              <h4 class="font-medium text-blue-900 mb-3">{{ 'SYSTEM_SETTINGS.SERIALIZATION.QUICK_PRESETS' | translate }}</h4>
              <div class="row">
                @for (preset of presetEntries; track preset.key) {
                  <div class="col-12 col-md-6">
                    <div class="border p-3 rounded mb-3 bg-white">
                      <div class="flex items-center justify-between mb-2">
                        <h5 class="font-medium text-sm">{{ preset.value.name }}</h5>
                        <button data-testid="copy-presets-btn" type="button" (click)="copyPresetValues(preset.key)" title="Copy to clipboard"
                        class="link borderless-btn">{{ 'SYSTEM_SETTINGS.SERIALIZATION.BTN_COPY' | translate }}</button>
                      </div>
                      <div class="text-xs font-mono bg-gray-100 p-2 rounded">
                        {{ preset.value.preview }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <!-- Dynamic character set fields -->
            @for (char of maskTranslationKeys; track char) {
              <div class="rounded-card mb-4">
                <div class="flex items-center justify-between mb-3">
                  <div class="flex items-center space-x-3">
                    <div class="circle-wr flex items-center justify-center font-mono font-semibold">
                      {{ char }}
                    </div>
                    <div class="flex flex-col justify-center">
                      <h4 class="font-medium">{{ 'Character type "' + char + '" possible values' }}</h4>
                      <small class="text-gray-500">{{ maskTranslation[char].length || 0 }} characters defined</small>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <button data-testid="remove-presets-btn" class="btn borderless-btn btn-icon icon-trash"
                      pTooltip="{{ 'SYSTEM_SETTINGS.SERIALIZATION.BTN_REMOVE_PRESET' | translate }}" tooltipPosition="top"
                    (click)="removeMaskChar(char)"></button>
                  </div>
                </div>
                <textarea class="text-field font-mono text-sm" rows="3" [value]="maskTranslation[char].join(', ') || ''"
                  (input)="handleMaskTranslationChange(char, $event)"
                placeholder="Enter comma-separated values (e.g., A, B, C, D, E, F)"></textarea>
              </div>
            }
          </div>
        </section>
      }
      <!-- Preview -->
      @if (showMaskConfiguration) {
        <section class="col-12 mb-4">
          @if (showPreview) {
            <div>
              <div class="px-6 pt-3 pb-3 bg-gray border rounded">
                <h3 class="section-subtitle mt-0">{{ 'SYSTEM_SETTINGS.SERIALIZATION.MASK_OUTPUT_SAMPLE' | translate }}</h3>
                <div class="font-mono bg-white p-3 border rounded mt-2">
                  {{ previewText }}
                </div>
                <small class="text-sm mt-4 block italic">
                  {{ 'SYSTEM_SETTINGS.SERIALIZATION.DESCRIPTION_SAMPLE_OUTPUT' | translate }}
                </small>
              </div>
            </div>
          } @else {
            <div class="mt-4">
              <p class="text-base">
                {{ 'SYSTEM_SETTINGS.SERIALIZATION.NO_CHARACTER_SETS_DEFINED' | translate }}
              </p>
            </div>
          }
        </section>
      }
      <!-- Submit -->
      <div class="row">
        <div class="col-12 mt-6 mb-4 pt-8 border-t">
          <div class="flex items-center justify-end gap-3">
            @if (editingSetting) {
              <button data-testid="edit-serialisation-btn" id="btn-cancel-serialization-edit" type="button" class="btn outline-btn" (click)="cancelEdit()">{{ 'SYSTEM_SETTINGS.SERIALIZATION.CANCEL_SERIALIZATION_SETTINGS_EDIT_BTN' | translate }}</button>
            }
            <button data-testid="save-serialisation-btn" class="btn primary-btn" [disabled]="generatorForm.invalid || isCustomAlgorithmInvalid()" (click)="saveSerializationSetting()">
              {{ editingSetting ? ('SYSTEM_SETTINGS.SERIALIZATION.UPDATE_SERIALIZATION_SETTINGS_BTN' | translate) : ('SYSTEM_SETTINGS.SERIALIZATION.CREATE_SERIALIZATION_SETTINGS_BTN' | translate) }}
            </button>
          </div>
        </div>
      </div>
    </form>
  }

  <!-- Display serialization settings -->
  @if (!loadingSettings && serializationSettings.length > 0 && !showCreateForm) {
    <section class="row mr-0 ml-0">
      <div class="flex flex-col col-12 pt-3 px-0">
        @for (setting of serializationSettings; track setting) {
          <div class="border rounded p-4 mb-4 bg-white">
            <div class="flex justify-between items-end mb-4">
              <h3 class="text-xl m-0">{{ getTypeLabel(mapTypeFromBackend(setting.codeType)) }}</h3>
              <button class="btn outline-btn" type="button" (click)="editGenerator(setting)">Edit</button>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4">
                <div class="p-3 bg-gray">
                  <div class="text-sm">{{ 'SYSTEM_SETTINGS.SERIALIZATION.ALGORITHM_TYPE' | translate }}</div>
                  <div class="font-medium">{{ getAlgorithmLabel(mapAlgorithmFromBackend(setting.algorithmType)) }}</div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="p-3 bg-gray">
                  <div class="text-sm">{{ 'SYSTEM_SETTINGS.SERIALIZATION.CODE_LENGTH' | translate }}</div>
                  <div class="font-medium">{{ setting.codeLength | defaultValue }}</div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4">
                <div class="p-3 bg-gray">
                  <div class="text-sm">{{ 'SYSTEM_SETTINGS.SERIALIZATION.OUTPUT_FORMAT' | translate }}</div>
                  <div class="font-medium">{{ getOutputFormatLabel(mapOutputFormatFromBackend(setting.outputFormatType)) }}</div>
                </div>
              </div>
            </div>
            @if (setting.algorithmType === 'CUSTOM' && setting.mask) {
              <div>
                <div class="mt-4">
                  <div class="text-sm font-medium mb-2">Mask Pattern</div>
                  <div class="font-mono bg-gray p-3 rounded border">
                    {{ setting.mask | defaultValue }}
                  </div>
                </div>
              </div>
            }
            <!-- mask translation -->
            @if (setting.algorithmType === 'CUSTOM' && setting.maskTranslation &&getMaskTranslationEntries(setting.maskTranslation).length > 0) {

              <div class="mt-4">
                <div class="text-sm font-medium mb-2">Character sets</div>
                <div class="row">
                  @for (entry of getMaskTranslationEntries(setting.maskTranslation); track entry.char) {
                    <div class="col-12 col-md-6 col-lg-6 mb-4">
                      <div class="border rounded p-3 h-full">
                        <div class="flex items-center mb-2">
                          <div
                            class="circle-wr font-mono font-bold flex items-center justify-center bg-gray border rounded-full mr-3">
                            {{ entry.char }}
                          </div>
                          <span class="text-sm font-medium">{{ entry.values.length || 0 }} Possible values defined:</span>
                        </div>
                        <div class="bg-gray p-3 font-mono text-sm">
                          {{ entry.values.join(', ') }}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </section>
  }
</div>
